import UserType from 'constants/user';
import { useAuth } from 'contexts/AuthContext';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { RootState } from 'redux/store';
import { PATH } from 'routes/constant';

export default function PrivateRouteStylist({ component: Component, ...rest }) {
    const { currentUser } = useAuth();
    const user = useSelector((state: RootState) => state.userDetail.me);
    return (
        <Route
            {...rest}
            render={(props) => {
                let { location } = props;

                return currentUser ? (
                    user && user.userType === UserType.Stylist && user?.approved ? (
                        <Component {...props} />
                    ) : (
                        <Redirect
                            to={{
                                pathname: PATH.HOME,
                                state: { from: location },
                            }}
                        />
                    )
                ) : (
                    <Redirect
                        to={{
                            pathname: PATH.LOGIN,
                            state: { from: location },
                        }}
                    />
                );
            }}
        />
    );
}
